import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { DeveloperFilter as DeveloperFilterModel, DeveloperFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const DeveloperFilter = (props: {
  filter: DeveloperFilterModel;
  setFilter: (value: DeveloperFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<DeveloperFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.developers.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const developerTypeField = () => {
    const propertyName = pn<DeveloperFilterModel>("developerTypeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.developerTypes?.find((x) => x.id === props.filter.developerTypeId)}
        options={resource.developerTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.developerTypeId = value?.id;
            })
          )
        }
      />
    );
  };

  const genderField = () => {
    const propertyName = pn<DeveloperFilterModel>("genderId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.genders?.find((x) => x.id === props.filter.genderId)}
        options={resource.genders}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.genderId = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {developerTypeField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {genderField()}
      </Grid>
    </Grid>
  );
};
